var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.0005V8.50049C4 7.30701 4.47411 6.16242 5.31802 5.31851C6.16193 4.47459 7.30653 4.00049 8.5 4.00049C9.69347 4.00049 10.8381 4.47459 11.682 5.31851C12.5259 6.16242 13 7.30701 13 8.50049V15.5005C13 16.1635 13.2634 16.7994 13.7322 17.2683C14.2011 17.7371 14.837 18.0005 15.5 18.0005C16.163 18.0005 16.7989 17.7371 17.2678 17.2683C17.7366 16.7994 18 16.1635 18 15.5005V8.83049C17.3325 8.59458 16.7699 8.13029 16.4116 7.51968C16.0534 6.90907 15.9225 6.19146 16.0422 5.4937C16.1619 4.79593 16.5244 4.16294 17.0656 3.70661C17.6069 3.25028 18.292 3 19 3C19.708 3 20.3931 3.25028 20.9344 3.70661C21.4756 4.16294 21.8381 4.79593 21.9578 5.4937C22.0775 6.19146 21.9466 6.90907 21.5884 7.51968C21.2301 8.13029 20.6675 8.59458 20 8.83049V15.5005C20 16.694 19.5259 17.8386 18.682 18.6825C17.8381 19.5264 16.6935 20.0005 15.5 20.0005C14.3065 20.0005 13.1619 19.5264 12.318 18.6825C11.4741 17.8386 11 16.694 11 15.5005V8.50049C11 7.83745 10.7366 7.20156 10.2678 6.73272C9.79893 6.26388 9.16304 6.00049 8.5 6.00049C7.83696 6.00049 7.20107 6.26388 6.73223 6.73272C6.26339 7.20156 6 7.83745 6 8.50049V15.0005H9L5 20.0005L1 15.0005H4Z",
    fill: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting);
export default __webpack_public_path__ + "static/media/routing.533d59cbe1a2dd9ec5e09899e850a5d9.svg";
export { ForwardRef as ReactComponent };